/**
 * ImageFeatures Component
 *
 * Features section showcasing image generation capabilities.
 */

import { memo } from 'react';
import { ImageIcon, Palette, Sparkles } from 'lucide-react';
import { useTranslation } from '../../hooks/useTranslation';

export const ImageFeatures = memo(function ImageFeatures() {
  const { t } = useTranslation();

  return (
    <div className="grid grid-cols-1 md:grid-cols-3 gap-6 mt-12">
      <div className="text-center p-6">
        <div className="w-12 h-12 bg-purple-100 rounded-lg flex items-center justify-center mx-auto mb-4">
          <ImageIcon className="h-6 w-6 text-purple-600" />
        </div>
        <h3 className="font-semibold text-secondary-900 mb-2">
          {t('image.features.quality.title', { defaultValue: 'High Quality' })}
        </h3>
        <p className="text-sm text-secondary-600">
          {t('image.features.quality.description', {
            defaultValue: 'Generate stunning high-resolution images up to 2K',
          })}
        </p>
      </div>

      <div className="text-center p-6">
        <div className="w-12 h-12 bg-pink-100 rounded-lg flex items-center justify-center mx-auto mb-4">
          <Palette className="h-6 w-6 text-pink-600" />
        </div>
        <h3 className="font-semibold text-secondary-900 mb-2">
          {t('image.features.styles.title', { defaultValue: 'Multiple Styles' })}
        </h3>
        <p className="text-sm text-secondary-600">
          {t('image.features.styles.description', {
            defaultValue: 'Choose from dozens of art styles and presets',
          })}
        </p>
      </div>

      <div className="text-center p-6">
        <div className="w-12 h-12 bg-blue-100 rounded-lg flex items-center justify-center mx-auto mb-4">
          <Sparkles className="h-6 w-6 text-blue-600" />
        </div>
        <h3 className="font-semibold text-secondary-900 mb-2">
          {t('image.features.control.title', { defaultValue: 'Full Control' })}
        </h3>
        <p className="text-sm text-secondary-600">
          {t('image.features.control.description', {
            defaultValue: 'Fine-tune every aspect of your image generation',
          })}
        </p>
      </div>
    </div>
  );
});
